// extracted by extract-css-chunks-webpack-plugin
module.exports = {"alert-msg":"alert-msg","alert-content":"alert-content","Alert__flair":"Alert__flair"};